/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import mbpLogger from 'mbp-logger';
import QueryString from 'qs';

import { useRef, useState, useEffect } from 'react';

export function usePrevious(value) {
    const ref = useRef();
    useEffect(() => {
        ref.current = value;
    });
    return ref.current;
}

// attempt, success, and fail helper methods
let totalAttempts = 0;
const incrementAttempts = (callback, interval, maxAttempts) => {
    totalAttempts += 1;

    if (typeof maxAttempts !== 'undefined') {
        if (totalAttempts > maxAttempts) {
            clearInterval(interval);
            callback();

            const urlPath = window.location.pathname || '';

            mbpLogger.logError({
                appName: process.env.npm_package_name,
                jsError: {
                    callback,
                    interval,
                    maxAttempts,
                    urlPath,
                },
                function: 'incrementAttempts',
                module: 'mbp-tag-managment',
                message: `Reached maximum number of attempts. Going to stop checking. [urlPath: ${urlPath}]`,
            });
        }
    }
};

const timer = (args, test, callback, sleep, maxAttempts) => {
    const interval = setInterval(() => {
        try {
            if (test(...args)) {
                clearInterval(interval);
                callback();
            } else {
                incrementAttempts(callback, interval, maxAttempts);
            }
        } catch (e) {
            mbpLogger.logError({
                appName: process.env.npm_package_name,
                args,
                callback,
                sleep,
                maxAttempts,
                jsError: e,
                function: 'timer',
                module: 'mbp-tag-managment',
                message: 'Failure in check.',
            });

            incrementAttempts(callback, interval, maxAttempts);
        }
    }, sleep);
};

export const when = (test, callback, sleep = 100, maxAttempts) => {
    totalAttempts = 0;
    // eslint-disable-next-line no-undef
    const args = Array.prototype.slice.call(arguments, 2);

    timer(args, test, callback, sleep, maxAttempts);
};

/*
 * @description hook to find the intersection between two elements
 * @param {object} First Param
 * @return {array} Element reference and intersection object
 */
export const useIntersect = ({ root = null, rootMargin, threshold = 1 }) => {
    const [entry, updateEntry] = useState({});
    const [node, setNode] = useState(null);
    const observer = useRef(null);
    useEffect(() => {
        if (observer.current) observer.current.disconnect();
        observer.current = new window.IntersectionObserver(([entryValue]) => updateEntry(entryValue), { root, rootMargin, threshold });
        const { current: currentObserver } = observer;
        if (node) currentObserver.observe(node);
        return () => currentObserver.disconnect();
    }, [node]);
    return [setNode, entry];
};

export const setProductDemandType = (history, demandType) => {
    history.push({
        search: `demandType=${demandType}`,
    });
};

export const getProductDemandType = (location) => QueryString.parse(location.search.replace('?', ''))?.demandType;

export const getAttributeByName = (attributeList, attributeName) => {
    let attribute = [];
    if (attributeList?.length > 0) {
        attribute = attributeList.filter((attr) => attr.id === attributeName && attr.values?.[0]?.value === 'true') || [];
    }

    return attribute;
};

export const getProductAttributeByName = (attributeList, attributeName) => {
    let attribute = [];
    if (attributeList?.length > 0) {
        attribute = attributeList.filter((attr) => attr.attributeName === attributeName && attr.attributeValue) || [];
    }

    return attribute;
};

export const getPersAttrValueByName = (attributeName, attributeList) => {
    let attribute = null;

    if (attributeList?.length > 0) {
        attribute = attributeList.find((attr) => attr.perAttributeId === attributeName) || [];
    }

    return attribute?.perAttributeValue || '';
};

export default function getSiteConfig(item) {
    if (typeof window !== 'undefined' && typeof sessionStorage !== 'undefined') {
        const persistPage = sessionStorage ? sessionStorage.getItem('persist:page') : null;
        if (persistPage) {
            try {
                let brand;
                const { byId } = JSON.parse(JSON.parse(sessionStorage.getItem('persist:page')).brands);
                Object.keys(byId).forEach((key) => {
                    brand = key;
                });

                if (!brand) {
                    return null;
                }

                return byId[brand][item] || null;
            } catch (ex) {
                return null;
            }
        }
    }
    return null;
}

export const formatDiscount = (discount) => {
    if (discount) {
        const stringArr = Number(discount).toFixed(2).toString().split('');
        if (stringArr[0] === '-') {
            stringArr.unshift('-');
            stringArr[1] = '$';
        }
        return stringArr.join('');
    }

    return '';
};

export const getPageType = (history) => {
    if (history?.location?.pathname) {
        const path = history.location.pathname || '';
        if (path.indexOf('/cart/') > 0) {
            return 'cart';
        } if (path.indexOf('/shipping/') > 0) {
            return 'shipping';
        } if (path.indexOf('/payment/') > 0) {
            return 'payment';
        } if (path.indexOf('/payment-review/') > 0) {
            return 'payment-review';
        } if (path.indexOf('/review-order/') > 0) {
            return 'review-order';
        } if (path.indexOf('/confirmation/') > 0) {
            return 'confirmation';
        }
    }
    return '';
};

// Check if Card isle product have gift card
export const getCardIsleProductHasGiftCard = (orderItem) => {
    let hasGiftCard = false;
    if  (orderItem.addons?.length > 0) {
        orderItem.addons.forEach((addon) => {
            if (addon.itemInfo?.lineItemType === 'GIFTCARD') {
                hasGiftCard = true;
            }
        });
    }
    return hasGiftCard;
};
